import type { LinkHTMLAttributes } from 'react';
import { DEFAULT_LANGUAGE } from 'i18n/constants';

import { FILTER_PATH_SEPARATOR } from '@Modules/filters/constants';
import type { LanguageEnum } from '@Modules/app/constants';

import { removeLeadingString, removeTrailingString } from './path';

export const getListOfLinkDataForWebUriInfo = (
  info?: Record<LanguageEnum, string>,
  params?: { queryPath?: string; queryParams?: string }
): Array<LinkHTMLAttributes<HTMLLinkElement>> => {
  if (!info) {
    return [];
  }

  return Object.entries(info).reduce<Array<LinkHTMLAttributes<HTMLLinkElement>>>(
    (acc, [lang, link]) => {
      const linkParts = ['/', removeLeadingString(link, '/')];
      const { queryPath, queryParams } = params || {};

      if (queryPath) {
        linkParts.push(FILTER_PATH_SEPARATOR);
        linkParts.push(removeTrailingString(queryPath, '/'));
      }

      if (queryParams) {
        linkParts.push('?');
        linkParts.push(removeLeadingString(queryParams, '?'));
      }

      const resultLink = linkParts.join('');

      if (lang === DEFAULT_LANGUAGE) {
        acc.push({
          rel: 'alternate',
          hrefLang: 'x-default',
          href: resultLink,
        });
      }

      acc.push({
        rel: 'alternate',
        hrefLang: lang,
        href: resultLink,
      });

      return acc;
    },
    []
  );
};
